export default {
  upload: {
    clickToUpload: '点击上传',
    uploadFailed: '上传失败',
    imgLimitTips: '只能上传JPG/PNG/GIF文件，且不超过{imageMaxSize}MB。',
    imgTypeError: '图片只能是JPG/PNG/GIF格式!',
    imgSizeError: '图片大小不能超过{imageMaxSize}MB!',
    videoLimitTips: '只能上传mp4文件，且不超过{videoMaxSize}MB。',
    videoTypeError: '视频只能是mp4格式',
    videoSizeError: '视频大小不能超过{videoMaxSize}MB!',
    videoDuplicate: '已上传视频',
    clickToUploadVideo: '点击上传视频',
    clickToUploadVideoCover: '点击上传视频封面',
    suggestion: '推荐尺寸为{size}。',
    fileTips: '可以上传PDF/文档/图片/HTML文件，大小不超过{maxSize}MB!',
    fileTypeError: '文件只能是PDF/文档/图片/HTML!',
    fileSizeError: '文件大小不能超过{maxSize}MB!'
  }
}
